import {inject} from '@angular/core';
import {CanActivateChildFn} from '@angular/router';
import {catchError, map, of} from 'rxjs';
import {ToastService} from '../../shared/service/toast.service';
import {ToastType} from '../../shared/components/toast/toast.model';
import {TranslationBundle} from './feature-translate.loader';
import {FeatureTranslationService} from './feature-translation.service';

const ROUTE_BUNDLES: Record<string, TranslationBundle[]> = {
    audio: ['audio', 'teaser'], images: ['teaser'], translator: ['translator'],
    'ai-detector': ['detector', 'teaser'], paraphraser: ['paraphraser'],
    presentations: ['presentations'], subscription: ['plans'], 'upgrade-subscription': ['teaser', 'plans'],
};

export const featureTranslationGuard: CanActivateChildFn = (_route, state) => {
    const feature = state.url.split(/[/?#]/)[2];
    const bundles = ROUTE_BUNDLES[feature] ?? [];
    if (!bundles.length) return true;
    const toast = inject(ToastService);
    return inject(FeatureTranslationService).ensure(...bundles).pipe(
        map(() => true),
        catchError(() => {
            toast.broadcast(ToastType.TOAST, {
                level: 'danger', title: 'error.apps.load.failed.title', content: 'error.apps.load.failed.desc',
            });
            return of(false);
        }),
    );
};
